





























import { defineComponent, ref } from "@nuxtjs/composition-api";

import PartFinderSimple from "./PartFinderSimple.vue";
import LicensePlateFinderSimple from "./LicensePlateFinderSimple.vue";

import { SfButton } from "@storefront-ui/vue";

export default defineComponent({
    name: "PartAndLicensePlateFinder",
    components: {
        PartFinderSimple,
        LicensePlateFinderSimple,
        SfButton,
    },
    props: {
        pfButtonText: {
            type: String,
            default: "",
        },
        lpfButtonText: {
            type: String,
            default: "",
        },
    },
    setup() {
        const showLicensePlateFinder = ref(false);

        const changeLicensePlateFinderVisibility = () => {
            showLicensePlateFinder.value = !showLicensePlateFinder.value;
        };

        return {
            showLicensePlateFinder,
            changeLicensePlateFinderVisibility,
        };
    },
});
